import { createFileRoute } from '@tanstack/react-router';
import { CifsPage, lerBuscaCifs } from '@/components/cifs';

export const Route = createFileRoute('/_app/custos/cifs')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaCifs(bruto),
  component: CifsRota,
});

function CifsRota() {
  return <CifsPage busca={Route.useSearch()} />;
}
